module.exports = __webpack_public_path__ + "static/media/stopButton_1.922fb059.mp3";